import { render, staticRenderFns } from "./ProviderMultiselect.vue?vue&type=template&id=06639b7a&scoped=true&"
import script from "./ProviderMultiselect.vue?vue&type=script&lang=js&"
export * from "./ProviderMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./ProviderMultiselect.vue?vue&type=style&index=0&id=06639b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06639b7a",
  null
  
)

export default component.exports